import { Box } from '@chakra-ui/react'
import { type ConditionalValue } from '@chakra-ui/react'
import React, { useMemo } from 'react'
import {
  ExtensionBadgeVariant,
  useExtensionBadgeStyles,
} from '~/components/shared/componentStyles/ExtensionBadge.style'
import { HighlightText } from '~/components/shared/HighlightText'
import { Size } from '~/types/ThemeTypes'

interface ExtensionBadgeProps {
  extension?: string | number
  searchTerm?: string
  size?: ConditionalValue<Size.sm | Size.md | Size.lg | Size.xl>
  variant?: ExtensionBadgeVariant
}

export const ExtensionBadge = ({
  extension,
  searchTerm = '',
  size = [Size.sm, Size.md],
  variant,
}: ExtensionBadgeProps) => {
  const styles = useExtensionBadgeStyles({
    size,
    variant,
  })

  const textNode = useMemo(() => {
    return (
      <HighlightText css={styles.text} query={[searchTerm]}>
        {extension?.toString() ?? ''}
      </HighlightText>
    )
  }, [extension, searchTerm])

  return <Box css={styles.container}>{textNode}</Box>
}
